import { writable } from "svelte/store";
import { fetchWithSession } from "../util/fetchWithSession";

export function createApplicationLimitationStore() {
  const { subscribe, set, update } = writable({
    applicationLimitations: [],
    applicationLimitationType: "",
    currentApplicationLimitation: {},
    applicationLimitationModalOpen: false,
  });

  async function getApplicationLimitations(idLimitation) {
    try {
      const res = await fetchWithSession(
        `/api/damprojects/limitations/${idLimitation}`
      );
      if (!res?.ok) return;
      const data = await res.json();
      update((state) => ({
        ...state,
        applicationLimitations: data.items,
        applicationLimitationType: data.type,
      }));
    } catch (err) {
      console.log(err);
    }
  }

  function addApplications(addedApplications) {
    if (addedApplications.length > 0) {
      addedApplications.forEach((application) => {
        saveApplicationLimitationItem(application);
      });
      addedApplications = [];
    }
  }

  async function saveApplicationLimitationItem(
    currentApplicationLimitation,
    idLimitation
  ) {
    const { id, ...applicationData } = currentApplicationLimitation;
    const isUpdate = id && id !== null && id !== undefined;

    let payload = {
      idlimitation: idLimitation,
      ...applicationData,
    };
    try {
      const response = await fetchWithSession(
        isUpdate
          ? `/api/damprojects/limitation-items/${id}`
          : `/api/damprojects/limitation-items`,
        {
          method: isUpdate ? "PATCH" : "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      if (!response?.ok) return; // fetchWrapper already toasted the error
      const res = await response.json();
      if (res.error) {
        return;
      }
      const data = res.data;
      if (data.id !== currentApplicationLimitation.id) {
        const newApplicationLimitation = {
          ...currentApplicationLimitation,
          id: data.id,
        };
        update((state) => ({
          ...state,
          applicationLimitations: [
            ...state.applicationLimitations,
            newApplicationLimitation,
          ],
        }));
      } else {
        update((state) => ({
          ...state,
          applicationLimitations: state.applicationLimitations.map((x) =>
            x.id === currentApplicationLimitation.id
              ? currentApplicationLimitation
              : x
          ),
        }));
      }
      update((state) => ({
        ...state,
        applicationLimitationModalOpen: false,
      }));
    } catch (err) {
      // fetchWrapper already toasted the network error
      console.log(err);
    }
  }

  async function updateDAMLimitation(idLimitation, applicationLimitationType) {
    try {
      const response = await fetchWithSession(
        `/api/damprojects/limitations/${idLimitation}`,
        {
          method: "PATCH",
          body: JSON.stringify({ type: applicationLimitationType }),
        }
      );
      if (!response?.ok) return; // fetchWrapper already toasted the error
      const res = await response.json();
    } catch (err) {
      console.log(err);
    }
  }

  function editApplicationLimitationItem(id) {
    let currentApplicationLimitation = {
      id: null,
      isbrowser: 0,
      name: "",
      appname: "",
      windowtitle: "",
      url: "",
    };
    update((state) => ({
      ...state,
      currentApplicationLimitation:
        id !== 0
          ? { ...state.applicationLimitations.find((x) => x.id === id) }
          : currentApplicationLimitation,
      applicationLimitationModalOpen: true,
    }));
  }

  async function deleteApplicationLimitation(id) {
    try {
      const res = await fetchWithSession(
        `/api/damprojects/limitation-items/${id}`,
        {
          method: "DELETE",
        }
      );
      if (!res?.ok) return; // fetchWrapper already toasted the error
      const data = await res.json();
      if (data.error) {
        return;
      }
      update((state) => ({
        ...state,
        applicationLimitations: state.applicationLimitations.filter(
          (x) => x.id !== id
        ),
      }));
    } catch (err) {
      // fetchWrapper already toasted the network error
      console.log(err);
    }
  }

  function closeModal() {
    update((state) => ({
      ...state,
      applicationLimitationModalOpen: false,
    }));
  }

  return {
    subscribe,
    getApplicationLimitations,
    addApplications,
    saveApplicationLimitationItem,
    updateDAMLimitation,
    editApplicationLimitationItem,
    deleteApplicationLimitation,
    closeModal,
  };
}

export const applicationLimitationStore = createApplicationLimitationStore();
